import { render, staticRenderFns } from "./ReportAdm.vue?vue&type=template&id=43240244&"
import script from "./ReportAdm.vue?vue&type=script&lang=js&"
export * from "./ReportAdm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports